function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createContext, useContext } from 'react';
import { getTraceId, request, useMutation, useQuery, useQueryClient } from '@applyboard/ui-utils';
import { FormDefinition } from "../../../components/DynamicForm";
import { JsonLogic, JsonLogicLegacyBooleanStructure } from "../../../components/JsonLogicInput";
import { JsonSchema as AcceptedObjectsJsonSchema, ArrayOfUniqueStrings, QuestionOptionsPropertySchema, EnumDisplayNameRefinement } from "../../../types";
import { updateAggregatedDataCache, filterByType, findByType } from "../../../data";
import { Workflow } from "../types";
import { z } from 'zod';
import { P, isMatching } from 'ts-pattern';
import { produce } from 'immer';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var FormQuestionPropertySchema = z.object({
  title: z.string(),
  type: z.literal('string'),
  "default": z.string().optional(),
  // "form-question" is a custom format that indicates the string
  // should be the ID of a form question.  In the property panel, this
  // allows us to show a dropdown of all question IDs instead of a
  // textfield
  //
  // jsonschema allows "custom formats" as specified here:
  // https://json-schema.org/understanding-json-schema/reference/string#format
  format: z.literal('form-question')
});
var AcceptedObjects = z.record(z.string(), AcceptedObjectsJsonSchema);
export var JsonLogicPropertySchema = z.object({
  title: z.string(),
  type: z.literal('object'),
  'x-acceptedObjects': AcceptedObjects
}).transform(function (value) {
  return _objectSpread(_objectSpread({}, value), {}, {
    // TODO: remove this after BE adds this field
    'x-type': 'json-logic'
  });
});
export var TruthTableSchema = z.object({
  type: z.literal('object'),
  'x-type': z.literal('truth-table'),
  'x-acceptedObjects': AcceptedObjects
});
var StringEnumProperty = z.object({
  title: z.string(),
  type: z.literal('string'),
  "default": z.string().optional(),
  "enum": ArrayOfUniqueStrings,
  'x-enumNames': ArrayOfUniqueStrings.optional()
});
var StringProperty = z.object({
  title: z.string(),
  type: z.literal('string'),
  "default": z.string().optional(),
  format: z.union([z.literal('date'), z.literal('date-time'), z.literal('form-question-option')]).optional(),
  maxLength: z.number().optional(),
  minLength: z.number().optional()
});
var NumberProperty = z.object({
  title: z.string(),
  type: z.literal('number'),
  "default": z.number().optional()
});
var BooleanProperty = z.object({
  title: z.string(),
  type: z.literal('boolean'),
  "default": z["boolean"]().optional()
});
var DomainDynamicValueSchema = z.object({
  type: z.string(),
  title: z.string(),
  properties: z.record(z.string(), z.object({
    type: z.literal('string'),
    title: z.string()
  }))
});
var FormAnswersDynamicValueSchema = z.object({
  type: z.literal('object'),
  'x-type': z.literal('formAnswers'),
  title: z.string(),
  patternProperties: z.object({
    '.*': z.object({
      type: z.string()
    })
  })
});
var OutcomeDynamicValueSchema = z.object({
  type: z.literal('object'),
  'x-type': z.literal('nodes'),
  title: z.string(),
  patternProperties: z.object({
    '.*': z.object({
      type: z.literal('object'),
      properties: z.object({
        outcomes: z.object({
          type: z.literal('object'),
          patternProperties: z.object({
            '.*': z.object({
              properties: z.object({
                data: z.object({
                  type: z.literal('object'),
                  patternProperties: z.object({
                    '.*': z.union([z.object({
                      type: z.string()
                    }), QuestionOptionsPropertySchema.partial({
                      title: true
                    })])
                  })
                })
              })
            })
          })
        })
      })
    })
  })
});
var DynamicValuePropertySchema = z.object({
  title: z.string(),
  anyOf: z.tuple([z.union([StringEnumProperty.omit({
    title: true
  }), StringProperty.omit({
    title: true
  }), NumberProperty.omit({
    title: true
  }), BooleanProperty.omit({
    title: true
  }), FormQuestionPropertySchema.omit({
    title: true
  }), QuestionOptionsPropertySchema.omit({
    title: true
  })]).refine(function (value) {
    var _value$enum, _value$xEnumNames;
    if (!('enum' in value) || !('x-enumNames' in value)) {
      return true;
    }
    return ((_value$enum = value["enum"]) === null || _value$enum === void 0 ? void 0 : _value$enum.length) === ((_value$xEnumNames = value['x-enumNames']) === null || _value$xEnumNames === void 0 ? void 0 : _value$xEnumNames.length);
  }, EnumDisplayNameRefinement), z.object({
    type: z.literal('object'),
    'x-type': z.literal('dynamic-value'),
    properties: z.object({
      "var": z.object({
        type: z.literal('string'),
        format: z.literal('pointer'),
        'x-acceptedObjects': z.record(z.string(), z.union([DomainDynamicValueSchema, OutcomeDynamicValueSchema, FormAnswersDynamicValueSchema]))
      })
    })
  })])
});
export var QuestionOptionsValueSchema = z.object({
  question_key: z.string(),
  option_keys: z.string().array()
});
var JsonSchema = z.object({
  type: z.literal('object'),
  properties: z.record(z.string().refine(function (key) {
    return key !== 'templateId';
  }, {
    message: 'Property key can not be templateId'
  }), z.union([StringEnumProperty, StringProperty, NumberProperty, BooleanProperty, FormQuestionPropertySchema, TruthTableSchema, JsonLogicPropertySchema, DynamicValuePropertySchema, QuestionOptionsPropertySchema.partial({
    title: true
  })]).refine(function (value) {
    var _value$enum2, _value$xEnumNames2;
    if (!('enum' in value) || !('x-enumNames' in value)) {
      return true;
    }
    return ((_value$enum2 = value["enum"]) === null || _value$enum2 === void 0 ? void 0 : _value$enum2.length) === ((_value$xEnumNames2 = value['x-enumNames']) === null || _value$xEnumNames2 === void 0 ? void 0 : _value$xEnumNames2.length);
  }, EnumDisplayNameRefinement)).refine(function (value) {
    return Object.values(value).filter(function (schema) {
      return 'x-type' in schema && schema['x-type'] === 'truth-table';
    }).length <= 1;
  }, {
    message: 'Only one truth table is allowed'
  }),
  required: z.string().array().optional()
});
export var TruthTable = z.object({
  defaultOutcome: z.string(),
  rows: z.array(z.object({
    conditions: z.object({
      and: z.array(JsonLogic)
    }),
    outcome: z.object({
      id: z.string(),
      data: z.record(z.string(),
      // TODO: validate this using a jsonschema lib
      z.union([z.string(), z.union([z.object({
        question_key: z.string(),
        option_keys: z.array(z.string())
      }), z.object({
        questionKey: z.string(),
        optionKeys: z.array(z.string())
      })]).transform(function (value) {
        return {
          question_key: 'questionKey' in value ? value.questionKey : value.question_key,
          option_keys: 'optionKeys' in value ? value.optionKeys : value.option_keys
        };
      })]).optional()).optional()
    })
  }))
});
var NodeTemplatesResponseSchema = z.object({
  id: z.string(),
  type: z.literal('node_template'),
  attributes: z.object({
    kind: z.union([z.literal('process'), z.literal('decision'), z.literal('wait'), z.literal('start'), z.literal('end')]),
    name: z.string(),
    // The BE returns an empty object when there are no properties, which is
    // unfortunately not a valid JsonSchema.  To accommodate this, we convert
    // empty objects to undefined first and make this field optional
    properties: z.preprocess(convertEmptyObjectToUndefined, JsonSchema.optional()),
    outcomes: z.array(z.object({
      id: z.string(),
      displayName: z.string(),
      data: z.union([z.object({
        type: z.literal('object'),
        properties: z.record(z.string(), z.object({
          type: z.string(),
          title: z.string(),
          description: z.string()
        }).or(QuestionOptionsPropertySchema).or(z.undefined()))
      }).optional(),
      // TODO: remove this once APA-945 is merged
      z.array(z.unknown()).length(0).transform(function () {
        return undefined;
      })])
    })).optional()
  })
});
var RequirementTemplateSchema = z.object({
  id: z.string(),
  type: z.literal('hybrid'),
  attributes: z.object({
    classification: z.string(),
    externalLinks: z.array(z.object({
      id: z.number().optional(),
      link: z.string()
    })),
    description: z.string(),
    title: z.string(),
    internalDescription: z.string().nullish(),
    internalTitle: z.string(),
    applicationStage: z.string(),
    category: z.string(),
    tags: z.string().array(),
    flags: z.object({
      applyboardRequirement: z["boolean"](),
      applyproofCompatible: z["boolean"](),
      earlyAccess: z["boolean"](),
      official: z["boolean"](),
      optional: z["boolean"](),
      requiresFormPreparation: z["boolean"]()
    }),
    typeSpecificAttributes: z.object({
      formDefinition: FormDefinition.nullable(),
      evaluationWorkflow: Workflow.nullable(),
      published: z["boolean"]()
    }),
    attachments: z.array(z.object({
      id: z.string(),
      name: z.string(),
      contentType: z.string(),
      fileDownloadLink: z.string().optional()
    }))
  })
});
var RequirementClassificationSchema = z.object({
  id: z.union([z["enum"](['applicant_requirement', 'action_requirement', 'school_requirement']), z.string()]),
  type: z.literal('requirement_classification'),
  attributes: z.object({
    displayName: z.string()
  })
});
var ApplicationStageSchema = z.object({
  id: z.string(),
  type: z.literal('application_stages'),
  attributes: z.object({
    label: z.string(),
    value: z.string()
  })
});
var RequirementTagSchema = z.object({
  id: z.string(),
  type: z.literal('requirement_tag'),
  attributes: z.object({
    name: z.string()
  })
});
var RequirementCategorySchema = z.object({
  id: z.string(),
  type: z.literal('requirement_categories'),
  attributes: z.object({
    applicationStages: z.string().array(),
    categoryType: z.string(),
    label: z.string(),
    value: z.string()
  })
});
var AggregatedDataIncluded = z.array(z.discriminatedUnion('type', [ApplicationStageSchema, NodeTemplatesResponseSchema, RequirementTemplateSchema, RequirementCategorySchema, RequirementClassificationSchema, RequirementTagSchema]));
export var AggregatedDataResponse = z.object({
  included: AggregatedDataIncluded.superRefine(checkTruthTableHasValidOptions).superRefine(checkPropertiesAgainstTemplates).transform(fixLegacyBooleanJsonLogicStructure),
  meta: z.object({
    dateGenerated: z.string()
  })
});
function convertEmptyObjectToUndefined(val) {
  if (_typeof(val) === 'object' && val && Object.keys(val).length === 0) {
    return undefined;
  }
  return val;
}
var AggregatedData = z.object({
  response: AggregatedDataResponse,
  traceId: z.string().nullish()
});
export function useRequirementPageAggregatedData(options) {
  var requirementTemplateId = useRequirementTemplateId();
  var id = options.id || requirementTemplateId;
  return useQuery(['requirementPageAggregatedData', {
    pkg: 'ab-application',
    id: id
  }], function () {
    return request("/api/awa/pages/requirement-page/aggregated-data".concat(id ? "?requirementTemplateId=".concat(id) : ''), {
      allowAnonymous: false,
      schema: AggregatedData,
      getData: function () {
        var _getData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res, req) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return res.json();
              case 2:
                _context.t0 = _context.sent;
                _context.t1 = getTraceId(req);
                return _context.abrupt("return", {
                  response: _context.t0,
                  traceId: _context.t1
                });
              case 5:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function getData(_x, _x2) {
          return _getData.apply(this, arguments);
        }
        return getData;
      }()
    });
  }, {
    cacheTime: 0,
    refetchOnMount: false,
    select: function (_select) {
      function select(_x3) {
        return _select.apply(this, arguments);
      }
      select.toString = function () {
        return _select.toString();
      };
      return select;
    }(function (data) {
      try {
        return options.select(data.response);
      } catch (err) {
        if (err instanceof Error && data.traceId) {
          Object.assign(err, {
            traceId: data.traceId
          });
        }
        throw err;
      }
    }),
    useErrorBoundary: true
  });
}

/**
 * Performs a mutation against the requirement page.  Automatically
 * updates the client-side store of aggregated data when the mutation succeeds,
 * so the page is kept up to date and consistent with itself
 *
 * @note Please read this document for information: https://applyboard.atlassian.net/wiki/spaces/APP/pages/2862612698/Aggregated+Page-Level+Data-fetching
 */
export function useRequirementPageMutation(callback) {
  var queryClient = useQueryClient();
  return useMutation(function (mutationParams) {
    var mutationConfig = callback(mutationParams);
    return request("/api/awa/pages/requirement-page/data".concat(mutationConfig.url), {
      method: mutationConfig.method,
      schema: AggregatedData,
      body: mutationConfig.body,
      getData: function () {
        var _getData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(res, req) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return res.json();
              case 2:
                _context2.t0 = _context2.sent;
                _context2.t1 = getTraceId(req);
                return _context2.abrupt("return", {
                  response: _context2.t0,
                  traceId: _context2.t1
                });
              case 5:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function getData(_x4, _x5) {
          return _getData2.apply(this, arguments);
        }
        return getData;
      }()
    });
  }, {
    onSuccess: function onSuccess(newData) {
      var _newData$response$inc;
      var newId = (_newData$response$inc = newData.response.included.find(function (element) {
        return element.type === 'hybrid';
      })) === null || _newData$response$inc === void 0 ? void 0 : _newData$response$inc.id;
      if (!newId) {
        throw new Error('Missing requirement id');
      }
      updateAggregatedDataCache({
        newData: newData,
        queryKey: ['requirementPageAggregatedData', {
          id: newId,
          pkg: 'ab-application'
        }],
        queryClient: queryClient
      });
    }
  });
}
var RequirementTemplateIdContext = /*#__PURE__*/createContext(undefined);

/**
 * @param props.requirementId The requirement template ID of the current page
 */
export function RequirementTemplateIdProvider(props) {
  return _jsx(RequirementTemplateIdContext.Provider, {
    value: props.requirementTemplateId,
    children: props.children
  });
}
export function useRequirementTemplateId() {
  return useContext(RequirementTemplateIdContext);
}

/**
 * Validates that truth table conditions reference valid options from their schema.
 * For each truth table node in a hybrid requirement's workflow:
 * - Checks that the referenced template exists
 * - Verifies all condition values match the enum options defined in the schema
 * - Reports validation issues for any invalid condition values
 *
 * @param included - Array of templates, requirements and other schema items
 * @param ctx - Zod refinement context for reporting validation issues
 */
function checkTruthTableHasValidOptions(included, ctx) {
  var _requirementTemplate$;
  var nodeTemplates = filterByType(included, 'node_template');
  var requirementTemplate = findByType(included, 'hybrid');
  var nodes = requirementTemplate === null || requirementTemplate === void 0 ? void 0 : (_requirementTemplate$ = requirementTemplate.attributes.typeSpecificAttributes.evaluationWorkflow) === null || _requirementTemplate$ === void 0 ? void 0 : _requirementTemplate$.nodes;
  if (!nodes) return;
  var _loop = function _loop() {
    var _nodeTemplates$find;
    var node = nodes[nodeIdx];
    var schema = (_nodeTemplates$find = nodeTemplates.find(function (template) {
      return template.id === node.data.templateId;
    })) === null || _nodeTemplates$find === void 0 ? void 0 : _nodeTemplates$find.attributes.properties;
    var properties = node.data.properties;
    if (properties && schema && node.data.templateId === 'automated_decision_truth_table') {
      for (var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++) {
        var propertyKey = _Object$keys[_i];
        var acceptedObjects = TruthTableSchema.parse(schema.properties[propertyKey])['x-acceptedObjects'];
        var table = TruthTable.parse(properties[propertyKey]);
        var rowConditions = table.rows.map(function (row) {
          return row.conditions;
        });
        for (var rowIdx = 0; rowIdx < rowConditions.length; rowIdx++) {
          for (var conditionIdx = 0; conditionIdx < rowConditions[rowIdx].and.length; conditionIdx++) {
            var cond = rowConditions[rowIdx].and[conditionIdx];
            if (isMatching({
              "in": [{
                "var": P.string
              }, P.array(P.string)]
            }, cond)) {
              var _cond$in$;
              var _ref = ((_cond$in$ = cond["in"][0]) === null || _cond$in$ === void 0 ? void 0 : _cond$in$["var"].split('.')) || [],
                _ref2 = _slicedToArray(_ref, 2),
                objectKey = _ref2[0],
                attributeKey = _ref2[1];
              var obj = acceptedObjects[objectKey];
              if (objectKey in acceptedObjects && obj.type === 'object' && attributeKey in obj.properties) {
                for (var valueIdx = 0; valueIdx < cond["in"][1].length; valueIdx++) {
                  var value = cond["in"][1][valueIdx];
                  var attribute = obj.properties[attributeKey];
                  if ('enum' in attribute && typeof value === 'string' && !attribute["enum"].includes(value)) {
                    ctx.addIssue({
                      code: z.ZodIssueCode.custom,
                      message: "Not a valid option for ".concat(acceptedObjects[objectKey].title, " ").concat(attribute.title, "."),
                      path: ['0', 'attributes', 'typeSpecificAttributes', 'evaluationWorkflow', 'nodes', nodeIdx, 'data', 'properties', propertyKey, 'rows', rowIdx, 'conditions', 'and', conditionIdx, 'in', '1', valueIdx]
                    });
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  for (var nodeIdx = 0; nodeIdx < nodes.length; nodeIdx++) {
    _loop();
  }
  return;
}

/**
 * Validates that node properties match their corresponding template definitions.
 * For each node in a hybrid requirement's workflow:
 * - Checks that the referenced template exists
 * - Verifies all properties used in the node exist in the template's schema
 *
 * @param included - Array of templates, requirements and other schema items
 * @param ctx - Zod refinement context for reporting validation issues
 */
function checkPropertiesAgainstTemplates(included, ctx) {
  for (var itemIdx = 0; itemIdx < included.length; itemIdx++) {
    var _item$attributes$type;
    var item = included[itemIdx];
    if (item.type !== 'hybrid') {
      continue;
    }
    var nodes = (_item$attributes$type = item.attributes.typeSpecificAttributes.evaluationWorkflow) === null || _item$attributes$type === void 0 ? void 0 : _item$attributes$type.nodes;
    if (!nodes) continue;
    var _loop2 = function _loop2() {
        var _template$attributes$;
        var node = nodes[nodeIdx];
        var templateID = node.data.templateId;
        var properties = node.data.properties;
        if (!properties) return 0; // continue
        var template = filterByType(included, 'node_template').find(function (_ref3) {
          var id = _ref3.id;
          return id === templateID;
        });
        var templateProperties = (template === null || template === void 0 ? void 0 : (_template$attributes$ = template.attributes.properties) === null || _template$attributes$ === void 0 ? void 0 : _template$attributes$.properties) || {};
        var propertiesKeys = Object.keys(properties);
        if (Object.keys(templateProperties).length === 0 && propertiesKeys.length > 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Cannot find template with properties with ID ".concat(templateID),
            path: [itemIdx, 'attributes', 'typeSpecificAttributes', 'evaluationWorkflow', 'nodes', nodeIdx, 'data', 'templateId']
          });
          return 0; // continue
        }
        for (var _i2 = 0, _propertiesKeys = propertiesKeys; _i2 < _propertiesKeys.length; _i2++) {
          var propertyKey = _propertiesKeys[_i2];
          if (!(propertyKey in templateProperties)) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: "Property ".concat(propertyKey, " does not exist in the node template"),
              path: [itemIdx, 'attributes', 'typeSpecificAttributes', 'evaluationWorkflow', 'nodes', nodeIdx, 'data', 'properties', propertyKey]
            });
          }
        }
      },
      _ret;
    for (var nodeIdx = 0; nodeIdx < nodes.length; nodeIdx++) {
      _ret = _loop2();
      if (_ret === 0) continue;
    }
  }
}

/**
 * Transforms legacy boolean JSON logic structures into the modern format.
 * Specifically looks for json-logic properties in hybrid requirement nodes and converts
 * boolean conditions from the legacy "in" format to the modern "==" format.
 * This transformation only occurs if the target attribute's schema has type: 'boolean'.
 *
 * @param included - Array of templates, requirements and other schema items
 * @returns A new array with transformed boolean logic structures
 *
 * @example
 * // For a schema where student.isEnrolled has type: 'boolean':
 *
 * // Legacy format:
 * {
 *   "in": [
 *     { "var": "student.isEnrolled" },
 *     ["true"]
 *   ]
 * }
 *
 * // Gets converted to:
 * {
 *   "==": [
 *     { "var": "student.isEnrolled" },
 *     true
 *   ]
 * }
 *
 * // Note: No transformation occurs if the schema type is not boolean
 */
function fixLegacyBooleanJsonLogicStructure(included) {
  var nodeTemplateMap = getNodeTemplateMap(included);
  return produce(included, function (items) {
    var _iterator = _createForOfIteratorHelper(items),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        if (item.type === 'hybrid') {
          var _item$attributes$type2;
          var nodes = ((_item$attributes$type2 = item.attributes.typeSpecificAttributes.evaluationWorkflow) === null || _item$attributes$type2 === void 0 ? void 0 : _item$attributes$type2.nodes) || [];
          var _iterator2 = _createForOfIteratorHelper(nodes),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var node = _step2.value;
              if (!node.data.templateId) continue;
              var nodeTemplate = nodeTemplateMap.get(node.data.templateId);
              for (var nodePropertyKey in node.data.properties) {
                var _nodeTemplate$attribu, _nodeTemplate$attribu2;
                var nodePropertySchema = nodeTemplate === null || nodeTemplate === void 0 ? void 0 : (_nodeTemplate$attribu = nodeTemplate.attributes.properties) === null || _nodeTemplate$attribu === void 0 ? void 0 : (_nodeTemplate$attribu2 = _nodeTemplate$attribu.properties) === null || _nodeTemplate$attribu2 === void 0 ? void 0 : _nodeTemplate$attribu2[nodePropertyKey];
                if (!isMatching({
                  'x-type': 'json-logic'
                }, nodePropertySchema)) {
                  continue;
                }
                var logicResult = JsonLogicLegacyBooleanStructure.safeParse(node.data.properties[nodePropertyKey]);
                if (!logicResult.success) {
                  continue;
                }
                var attributeSchema = getAttributeSchemaFromVarStr(logicResult.data["in"][0]["var"], nodePropertySchema['x-acceptedObjects']);
                if ((attributeSchema === null || attributeSchema === void 0 ? void 0 : attributeSchema.type) !== 'boolean') {
                  continue;
                }
                node.data.properties[nodePropertyKey] = {
                  '==': [{
                    "var": logicResult.data["in"][0]["var"]
                  }, logicResult.data["in"][1][0] === 'true']
                };
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
}
function getAttributeSchemaFromVarStr(varStr, acceptedObjects) {
  var _varStr$split = varStr.split('.'),
    _varStr$split2 = _slicedToArray(_varStr$split, 2),
    objectName = _varStr$split2[0],
    attributeName = _varStr$split2[1];
  var objectSchema = acceptedObjects[objectName];
  if ((objectSchema === null || objectSchema === void 0 ? void 0 : objectSchema.type) === 'object') {
    return objectSchema.properties[attributeName];
  }
  return undefined;
}
function getNodeTemplateMap(included) {
  var nodeTemplateMap = new Map();
  var _iterator3 = _createForOfIteratorHelper(included),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var item = _step3.value;
      if (item.type === 'node_template') {
        nodeTemplateMap.set(item.id, item);
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return nodeTemplateMap;
}